import { InterviewStatus } from "src/types";

// Collections of messages to display in case the tables are empty
export function emptyInterviewTab(status: InterviewStatus, slug, navigate) {
  switch (status) {
    case "INVITED":
      return {
        active: {
          title: "There are no invited talents yet",
          text: "Once talents have been invited, they will appear here.",
          button: slug
            ? {
                onClick: () => navigate("/job/invite/" + slug),
                label: "Invite Talent"
              }
            : undefined
        },
        inactive: {
          title: "Talent cannot be invited to inactive job.",
          text: "Please make the job active if you would like to invite more talent to interview for this job."
        }
      };
    case "COMPLETED":
      return {
        active: {
          title: "There are no interviewed talents",
          text: "Once talents start taking interviews, they will appear here."
        },
        inactive: {
          title: "Talent cannot complete inactive job interview",
          text: "Please make the job active if you would like more talent to complete their interview."
        }
      };
    case "PASSED":
      return {
        active: {
          title: "There are no shortlisted talents",
          text: "Once talents are shortlisted, they will appear here."
        },
        inactive: {
          title: "There are no shortlisted talents",
          text: "Once talents are shortlisted, they will appear here."
        }
      };
    case "FAILED":
      return {
        active: {
          title: "There are no rejected talents",
          text: "Once talents are rejected, they will be shown here."
        },
        inactive: {
          title: "There are no rejected talents",
          text: "Once talents are rejected, they will be shown here."
        }
      };
  }
}
